import { COMP_COVERS_NEW } from './../Models/COMP_COVERS_NEW';
import {Injectable, Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'compCoversPipe',
  pure:false
})
@Injectable()
export class compCoversPipe implements PipeTransform {
  transform(compCovers: Array<COMP_COVERS_NEW>, sel:boolean): any {
    return compCovers.filter(t => t.isSelected==sel);
  }
}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pipes/compCoversPipe.ts